import instance from 'utils/axiosConfig';

/**
 * 검사 목록 조회 API
 * @param {Object} [params] - 쿼리 파라미터
 * @returns {Promise} API 응답 - 사용자 목록
 */
export const getClinicalTotalList = async (params) => {
    try {
        const response = await instance.get('/api/v1/clinical/user', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getClinicalDetail = async (patientUid) => {
    try {
        const response = await instance.get(`/api/v1/clinical/user/${patientUid}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
